import { Component } from '@angular/core';
import { PdfComponent } from '../pdf/pdf.component';
import { ActivatedRoute } from '@angular/router';
import { PageGeneralComponent } from '../../build-page-dynamic/page-general/page-general.component';
import { Toll } from '../../../shared/models/components-general/menu-toll.model';

@Component({
  selector: 'app-open-access',
  standalone: true,
  imports: [PdfComponent, PageGeneralComponent],
  templateUrl: './open-access.component.html',
})
export class OpenAccessComponent {
  public quotationId!: number;
  public typeAccess!: string;

  public tollArray: Toll[] = [
    // {
    //   icon: 'arrow_back',
    //   tolltip: 'Anterior Formulario',
    //   type: 'scroll',
    //   function: 'scrollLeft',
    // },
    {
      icon: 'arrow_forward',
      tolltip: 'Siguiente Formulario',
      type: 'scroll',
      function: 'scrollRight',
    },
    {
      icon: 'check',
      tolltip: 'Guardar Formulario',
      type: 'green',
      function: 'saveFrom',
    },
  ];

  constructor(private route: ActivatedRoute) {
    // Lee los parámetros de la ruta
    this.route.queryParams.subscribe((params) => {
      this.quotationId = params['quotationId'];
      this.typeAccess = params['typeAccess'];
    });
  }
}
